import React from 'react'

type Props = {}

const Footer = (props: Props) => {
    return (
        <footer id="footer" className="footer">
        </footer>
    )
}

export default Footer